import axios from 'axios'
// import { Message } from 'element-ui'

let API_POKER = process.env.VUE_APP_AXIOS
// if(location.hostname == '8.217.194.57' || location.hostname == 'localhost') {
//   API_POKER = '//beta10.kkpoker.co'
// }
// create an axios instance
const service = axios.create({
  baseURL: API_POKER // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // 增加时间戳
    config.params = {
      _t: Date.parse(new Date()) / 1000,
      ...config.params
    }

    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    return res
  },
  error => {
    console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)


export default service
